<template>
  <div id="how-it-works">
    <HeroSection :size="size" :theme="theme" class="bg-white">
      <div class="text-center mb-2">
        <h1 class="text-navy font-size-4">Our MortgageWatch service never sleeps</h1>
<!--        <h4 class="text-navy font-size-2 px-10 mt-3">Constantly talking to all UK lenders to find the latest mortgage deals for you</h4>-->
      </div>
      <div class="text-center">
        <img class="img-fluid w-60" src="/assets/svg/illustrations/person-with-boards.svg" alt="Image Description">
<!--        <img class="img-fluid w-75" src="/assets/svg/illustrations/ai-creation.svg" alt="Image Description">-->
        <div class="w-lg-75 w-sm-95 m-auto">
          <h4 class="text-navy font-size-2 my-4">Constantly talking to all UK lenders to find the latest mortgage deals for you.</h4>
        </div>
      </div>
      <ul class="step step-md step-centered mb-5 pb-5">
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">1</span>
            <div class="step-content">
              <h3 class="text-navy">Scouring the market 24/7</h3>
              <p class="text-navy">We continuously talk to all UK lenders to find the latest mortgage deals for our customers.</p>
            </div>
          </div>
        </li>
      
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">2</span>
            <div class="step-content">
              <h3 class="text-navy">Making millions of calculations</h3>
              <p class="text-navy">We match your unique requirements against thousands of products to find the best matches.</p>
            </div>
          </div>
        </li>
      
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">3</span>
            <div class="step-content">
              <h3 class="text-navy">Finding the best deals</h3>
              <p class="text-navy">We'll email you the best deals and you can use our mortgage explorer to investigate.</p>
            </div>
          </div>
        </li>
      </ul>
    </HeroSection>
  </div>
</template>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "HowItWorks",
  components: {HeroSection},
  
  props: {
    theme: {
      type: String,
      default: "home/how-it-works"
    },
    size: {
      type: String,
      default: "md"
    }
  }
};
</script>
